export const DECISION_MAKER = 'decision_maker';
export const ECONOMIC_BUYER = 'economic_buyer';
export const ECONOMIC_DECISION_MAKER = 'economic_decision_maker';
export const EXECUTIVE_SPONSOR = 'executive_sponsor';
export const TECHNICAL_BUYER = 'technical_buyer';
export const PRIMARY_CONTACT = 'primary_contact';
export const KEY_CONTACT = 'key_contact';

export const CONTACT_ECOSYSTEM_INSIGHTS = [
  {
    value: DECISION_MAKER,
    label: 'Decision Maker',
  },
  {
    value: ECONOMIC_BUYER,
    label: 'Economic Buyer',
  },
  {
    value: ECONOMIC_DECISION_MAKER,
    label: 'Economic Decision Maker',
  },
  {
    value: EXECUTIVE_SPONSOR,
    label: 'Executive Sponsor',
  },
  {
    value: TECHNICAL_BUYER,
    label: 'Technical Buyer',
  },
  {
    value: PRIMARY_CONTACT,
    label: 'Primary Contact',
  },
  {
    value: KEY_CONTACT,
    label: 'Key Contact',
  },
] as const;

export const VALID_CONTACT_ECOSYSTEM_INSIGHTS = new Set(
  CONTACT_ECOSYSTEM_INSIGHTS.map(({ value }) => value),
);
